import { Component } from '@angular/core';
import { ShotcategorymonthyearComponent } from '../reporting/shotcategorymonthyear/shotcategorymonthyear.component';
import { GrainMetricValueBarChart } from '../reporting/charts/grainMetricValueBarChart';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [GrainMetricValueBarChart],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {

}
